import { handleActions } from 'redux-actions'

import {
  SET_CLASIFICATIONS,
} from './clasifications.action'
import { LOGOUT } from '../../actions'

const initialState = {
  data: [],
}

export default handleActions({
  [SET_CLASIFICATIONS]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
